export default class SegmentString {
  getCoordinates() {}
  size() {}
  getCoordinate(i) {}
  isClosed() {}
  setData(data) {}
  getData() {}
}
export default class SegmentString {
  getCoordinates() {}
  size() {}
  getCoordinate(i) {}
  isClosed() {}
  setData(data) {}
  getData() {}
}
